import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-on-page-loader',
  templateUrl: './on-page-loader.component.html',
  styleUrls: ['./on-page-loader.component.css']
})
export class OnPageLoaderComponent {
  @Input() isLoading: boolean = false;
  @Input() loadingText: string = 'Loading...';
}
  